import { render, staticRenderFns } from "./StitchedMCQList.vue?vue&type=template&id=2811aeb0&"
import script from "./StitchedMCQList.vue?vue&type=script&lang=js&"
export * from "./StitchedMCQList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports